/**
 * @param {number} base
 * @return function(number): number
 */
export default (base)=>n=>Math.log(n)/(base ? Math.log(base) : 1);